import { KeyboardArrowDown } from "@mui/icons-material";

import AutoCompleteDropdown from "../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../ui library/HNSColors";
import { PAYMENTS_MODAL_STYLES } from "../../styles/styles";

export default function PaymentsSingleSelectDropdown(props) {
  const { fieldName, fieldValue, onChange, data = [], placeholder = "" } = props;
  const selectedOption = data.find((option) => option.id === fieldValue) ?? null;

  return (
    <AutoCompleteDropdown
      data={data}
      initValue={selectedOption}
      popupIcon={
        <KeyboardArrowDown sx={{ fontSize: 24, color: HNSColors.primary[500], marginRight: "8px" }} />
      }
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, optionValue) => option?.id === optionValue?.id}
      onValueChange={(_, value) => onChange(fieldName, value?.id ?? null)}
      ListboxProps={{
        sx: {
          maxHeight: 200,
          overflow: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: HNSColors.primary[500],
            borderRadius: "3px",
          },
        },
      }}
      placeholder={placeholder}
      textFieldSx={PAYMENTS_MODAL_STYLES.textField}
      dropdownSx={PAYMENTS_MODAL_STYLES.dropdownPaper}
      disableClearable={true}
    />
  );
}
